<!-- feature-info.component.html (PrimeNG 17+) -->
<p-dialog
  appendTo="body"
  styleClass="featureInfoDialog"
  header="INFO"
  [(visible)]="display"
  [resizable]="true"
  [draggable]="true"
  [baseZIndex]="2000000"
  [contentStyle]="{ overflow: 'hidden' }"
  (onHide)="onVisChange(false)"
>
  <p-toast key="featureInfoToast" [preventOpenDuplicates]="true"></p-toast>

  <!-- value-based tabs -->
  <p-tabs #tabViewEl class="compact-tabs" [(value)]="activeTabIndex">

    <!-- TAB HEADERS -->
    <p-tablist>
      <p-tab
        *ngFor="let info of stack; let i = index; trackBy: trackByFeatureId"
        [value]="i"
      >
        <div class="fiTabHeader">
          <span class="fiTabTitle">
            {{ getTabTitle(info) }}
          </span>

          <!-- IMPORTANT: use a custom class (NOT p-tab-close) -->
          <button
            type="button"
            class="fiTabClose"
            (click)="closeInfo({index:i}); $event.stopPropagation()"
            aria-label="Zapri zavihek"
            title="Zapri"
          >
            ✕
          </button>
        </div>
      </p-tab>
    </p-tablist>

    <!-- TAB CONTENT -->
    <p-tabpanels>
      <p-tabpanel
        *ngFor="let info of stack; let i = index; trackBy: trackByFeatureId"
        [value]="i"
      >
        <!-- NOTE: we DO NOT force display:flex on .p-tabpanel in CSS (PrimeNG needs to hide inactive ones) -->
        <div class="panelLayout" [class.street-active]="!!info.streetViewUrl">
          <div class="contentArea">
            <div class="infoScroll" *ngIf="!isDistrictHeatingFeature(info.feature) && !isDistrictHeatingInfo(info)">
              <table class="infoTable">
                <tr *ngFor="let item of info.keys">
                  <td
                    *ngIf="(info.attributes[item] | feature:item:'geometry') !== false"
                    class="attName"
                    [title]="getFeatureInfoColumnHoverText(item, info)"
                  >
                    {{ attrLabel(item) }}
                  </td>
                  <td *ngIf="(info.attributes[item] | feature:item:'geometry') !== false" class="attValue">
                    <div
                      [class.clickableCell]="isMolProjectInfoColumn(item, info)"
                      (click)="onMolProjectInfoColumnClick(info, item, $event)"
                    >
                      {{ replaceAll(info.attributes[item] + ' ', 'null', 'ni podatka') }}
                    </div>
                  </td>
                </tr>
              </table>
            </div>

            <div class="infoScroll" *ngIf="isDistrictHeatingFeature(info.feature) && info.dhLoading">
              <div class="dhLoadingBox">
                Nalaganje podatkov sistema daljinskega ogrevanja...
              </div>
            </div>

            <div class="infoScroll" *ngIf="isDistrictHeatingInfo(info)">

              <!-- ===================== SISTEM ===================== -->

              <!-- OVERVIEW - SISTEM -->
              <ng-container *ngIf="isDistrictHeatingSystem(info) && getDistrictHeatingView(info) === 'overview'">
              <table class="infoTable">
                  <tr>
                  <td class="attName">Naziv</td>
                  <td class="attValue">{{ info.districtHeatingData?.naziv }}</td>
                  </tr>
                  <tr>
                  <td class="attName">Lastnik</td>
                  <td class="attValue">{{ info.districtHeatingData?.lastnik }}</td>
                  </tr>
                  <tr>
                  <td class="attName">Upravljalec</td>
                  <td class="attValue">{{ info.districtHeatingData?.upravljalec }}</td>
                  </tr>
                  <tr>
                  <td class="attName">Dolžina cevnega sistema - dovodna cev (m)</td>
                  <td class="attValue">{{ info.districtHeatingData?.osnovniPodatki?.dolzina_cevnega_sistema_m }}</td>
                  </tr>
                  <tr>
                  <td class="attName">Volumen celotnega cevnega sistema (m<sup>3</sup>)</td>
                  <td class="attValue">{{ info.districtHeatingData?.osnovniPodatki?.volumen_cevnega_sistema_m3 }}</td>
                  </tr>
                  <tr>
                  <td class="attName">Število toplotnih postaj</td>
                  <td class="attValue">{{ info.districtHeatingData?.osnovniPodatki?.stevilo_toplotnih_postaj }}</td>
                  </tr>
                  <tr>
                  <td class="attName">Število odjemalcev</td>
                  <td class="attValue" style="white-space: pre-line;">
                      stanovanja: {{ info.districtHeatingData?.osnovniPodatki?.stevilo_odjemalcev_stanovanja }}
                      {{ '\n' }}poslovni del: {{ info.districtHeatingData?.osnovniPodatki?.stevilo_odjemalcev_poslovni_del }}
                      {{ '\n' }}industrija: {{ info.districtHeatingData?.osnovniPodatki?.stevilo_odjemalcev_industrija }}
                  </td>
                  </tr>
                  <tr>
                  <td class="attName">Deleži odjema toplote za predhodno leto (%)</td>
                  <td class="attValue" style="white-space: pre-line;">
                      gospodinjstva: {{ info.districtHeatingData?.osnovniPodatki?.delez_odjema_gospodinjstva_pct }}
                      {{ '\n' }}STV: {{ info.districtHeatingData?.osnovniPodatki?.delez_odjema_stv }}
                      {{ '\n' }}izgube cevovoda: {{ info.districtHeatingData?.osnovniPodatki?.delez_odjema_izgube }}
                      {{ '\n' }}ostali odjem: {{ info.districtHeatingData?.osnovniPodatki?.delez_odjema_ostalo }}
                  </td>
                  </tr>
                  <tr>
                  <td class="attName">Nazivna toplotna moč sistema (kW)</td>
                  <td class="attValue">{{ info.districtHeatingData?.osnovniPodatki?.nazivna_toplotna_moc_kw }}</td>
                  </tr>
                  <tr>
                  <td class="attName">Vrsta generatorja toplote</td>
                  <td class="attValue" style="white-space: pre-line;">
                      {{ info.districtHeatingData?.generator }}
                      <span *ngIf="info.districtHeatingData?.toplotniVir">
                      {{ '\nToplotni vir: ' + info.districtHeatingData?.toplotniVir }}
                      </span>
                  </td>
                  </tr>
                  <tr>
                  <td class="attName">Vrsta energenta</td>
                  <td class="attValue">{{ info.districtHeatingData?.energent }}</td>
                  </tr>
                  <tr>
                  <td class="attName">Regulacija</td>
                  <td class="attValue" style="white-space: pre-line;">
                      {{ info.districtHeatingData?.osnovniPodatki?.regulacija }}
                  </td>
                  </tr>
                  <tr>
                  <td class="attName">Letna proizvodnja toplote v kotlovnici (MWh/leto)</td>
                  <td class="attValue">{{ info.districtHeatingData?.osnovniPodatki?.letna_proizvodnja_toplote_mwh }}</td>
                  </tr>
                  <tr>
                  <td class="attName">Letna raba energenta (MWh/leto)</td>
                  <td class="attValue">{{ info.districtHeatingData?.osnovniPodatki?.letna_raba_energenta_mwh }}</td>
                  </tr>
                  <tr>
                  <td class="attName">Letne emisije CO₂ (t/leto)</td>
                  <td class="attValue">{{ info.districtHeatingData?.osnovniPodatki?.letne_emisije_co2_t }}</td>
                  </tr>
              </table>
              </ng-container>

              <!-- NAPOVED - SISTEM -->
              <ng-container *ngIf="isDistrictHeatingSystem(info) && getDistrictHeatingView(info) === 'napoved'">
              <table class="infoTable">
                  <tr>
                  <td class="attName">Naziv sistema</td>
                  <td class="attValue" [attr.colspan]="getDnevniColumns(info).length">
                      {{ info.districtHeatingData?.naziv }}
                  </td>
                  </tr>
                  <tr>
                  <td class="attName">Lastnik</td>
                  <td class="attValue" [attr.colspan]="getDnevniColumns(info).length">
                      {{ info.districtHeatingData?.lastnik }}
                  </td>
                  </tr>
                  <tr>
                  <td class="attName">Upravljalec</td>
                  <td class="attValue" [attr.colspan]="getDnevniColumns(info).length">
                      {{ info.districtHeatingData?.upravljalec }}
                  </td>
                  </tr>
                  <tr>
                  <td class="attName">Tip generatorja</td>
                  <td class="attValue" [attr.colspan]="getDnevniColumns(info).length" style="white-space: pre-line;">
                      {{ info.districtHeatingData?.generator }}
                      <span *ngIf="info.districtHeatingData?.toplotniVir">
                      {{ '\nToplotni vir: ' + info.districtHeatingData?.toplotniVir }}
                      </span>
                  </td>
                  </tr>
              </table>

              <br>

              <table class="infoTable">
                  <tr>
                  <th class="attName">Podatek</th>
                  <th class="attValue" *ngFor="let c of getDnevniColumns(info)" [innerHTML]="formatSlDate(c)">
                  </th>
                  </tr>
                  <tr *ngFor="let row of buildDnevneRows(info)">
                  <td class="attName">{{ row.naziv }} <span *ngIf="row.enota">({{ row.enota }})</span></td>
                  <td class="attValue" *ngFor="let c of getDnevniColumns(info)">
                      {{ formatSlNumber(row[c]) }}
                  </td>
                  </tr>
              </table>

              <br>

              <table class="infoTable">
                  <tr>
                  <th class="attName">Podatek</th>
                  <th class="attValue" *ngFor="let c of getNapovedColumns(info)" [innerHTML]="formatSlDate(c)">
                  </th>
                  </tr>
                  <tr *ngFor="let row of buildNapovedRows(info)">
                  <td class="attName">
                      {{ row.naziv }}
                      <span *ngIf="row.enota"> ({{ row.enota }})</span>
                  </td>
                  <td class="attValue" *ngFor="let c of getNapovedColumns(info)">
                      {{ formatSlNumber(row[c]) }}
                  </td>
                  </tr>
              </table>
              </ng-container>

              <!-- ZGODOVINA - SISTEM -->
              <ng-container *ngIf="isDistrictHeatingSystem(info) && getDistrictHeatingView(info) === 'zgodovina'">
              <table class="infoTable">
                  <tr>
                  <td class="attName">Naziv sistema</td>
                  <td class="attValue" [attr.colspan]="getZgodovinaColumns(info).length">
                      {{ info.districtHeatingData?.naziv }}
                  </td>
                  </tr>
                  <tr>
                  <td class="attName">Lastnik</td>
                  <td class="attValue" [attr.colspan]="getZgodovinaColumns(info).length">
                      {{ info.districtHeatingData?.lastnik }}
                  </td>
                  </tr>
                  <tr>
                  <td class="attName">Upravljalec</td>
                  <td class="attValue" [attr.colspan]="getZgodovinaColumns(info).length">
                      {{ info.districtHeatingData?.upravljalec }}
                  </td>
                  </tr>
                  <tr>
                  <td class="attName">Tip generatorja</td>
                  <td class="attValue" [attr.colspan]="getZgodovinaColumns(info).length" style="white-space: pre-line;">
                      {{ info.districtHeatingData?.generator }}
                      <span *ngIf="info.districtHeatingData?.toplotniVir">
                      {{ '\nToplotni vir: ' + info.districtHeatingData?.toplotniVir }}
                      </span>
                  </td>
                  </tr>
                  <tr>
                  <td class="attName">Letna proizvodnja toplote v kotlovnici (MWh/leto)</td>
                  <td class="attValue" [attr.colspan]="getZgodovinaColumns(info).length">
                      {{ info.districtHeatingData?.osnovniPodatki?.letna_proizvodnja_toplote_mwh }}
                  </td>
                  </tr>
                  <tr>
                  <td class="attName">Letna raba energenta (MWh/leto)</td>
                  <td class="attValue" [attr.colspan]="getZgodovinaColumns(info).length">
                      {{ info.districtHeatingData?.osnovniPodatki?.letna_raba_energenta_mwh }}
                  </td>
                  </tr>
                  <tr>
                  <td class="attName">Letne emisije CO₂ (t/leto)</td>
                  <td class="attValue" [attr.colspan]="getZgodovinaColumns(info).length">
                      {{ info.districtHeatingData?.osnovniPodatki?.letne_emisije_co2_t }}
                  </td>
                  </tr>
              </table>

              <br>

              <table class="infoTable">
                  <tr>
                  <th class="attName">Podatek</th>
                  <th class="attType">Vrsta</th>
                  <th class="attValue" *ngFor="let c of getZgodovinaColumns(info)" [innerHTML]="formatSlDate(c)">
                  </th>
                  </tr>

                  <ng-container *ngFor="let group of buildZgodovinaGroups(info)">
                  <tr *ngFor="let row of group.rows; let i = index">

                      <td
                      *ngIf="i === 0"
                      class="attName"
                      [attr.rowspan]="group.rows.length"
                      >
                      {{ group.naziv }}
                      <span *ngIf="group.enota"> ({{ group.enota }})</span>
                      </td>

                      <td class="attType">
                      {{ row.vrsta }}
                      </td>

                      <td class="attValue" *ngFor="let c of getZgodovinaColumns(info)">
                      {{ formatSlNumber(row[c]) }}
                      </td>

                  </tr>
                  </ng-container>
              </table>
              </ng-container>

              <!-- ===================== STAVBA ===================== -->

              <!-- OVERVIEW - STAVBA -->
              <ng-container *ngIf="isDistrictHeatingHouse(info) && getDistrictHeatingView(info) === 'overview'">
              <table class="infoTable">
                  <tr>
                  <td class="attName">Naslov stavbe</td>
                  <td class="attValue">{{ getHouseOsnovni(info)?.naslov }}</td>
                  </tr>
                  <tr>
                  <td class="attName">Številka toplotne postaje</td>
                  <td class="attValue">{{ getHouseOsnovni(info)?.stevilka_toplotne_postaje }}</td>
                  </tr>
                  <tr>
                  <td class="attName">Nazivna toplotna moč stavbe (kW)</td>
                  <td class="attValue">{{ getHouseOsnovni(info)?.nazivna_toplotna_moc_kw }}</td>
                  </tr>
                  <tr>
                  <td class="attName">Ocenjena letna raba energije (kWh/leto)</td>
                  <td class="attValue">{{ getHouseOsnovni(info)?.ocenjena_letna_raba_energije_kwh }}</td>
                  </tr>
                  <tr>
                  <td class="attName">Ocenjeno energetsko število stavbe (kWh/m<sup>2</sup>leto)</td>
                  <td class="attValue">{{ getHouseOsnovni(info)?.ocenjeno_energetsko_st_stavbe_kwh_m2_leto }}</td>
                  </tr>
                  <tr>
                  <td class="attName">Energetski razred stavbe</td>
                  <td class="attValue">{{ getHouseOsnovni(info)?.energetski_razred }}</td>
                  </tr>
                  <tr>
                  <td class="attName">Povprečna temperatura v stavbi (°C)</td>
                  <td class="attValue">{{ getHouseOsnovni(info)?.povprecna_temperatura_v_stavbi_c }}</td>
                  </tr>
                  <tr>
                  <td class="attName">Trenutna vstopna temperatura (°C)</td>
                  <td class="attValue">{{ getHouseOsnovni(info)?.trenutna_vstopna_temperatura_c }}</td>
                  </tr>
                  <tr>
                  <td class="attName">Trenutna izstopna temperatura (°C)</td>
                  <td class="attValue">{{ getHouseOsnovni(info)?.trenutna_izstopna_temperatura_c }}</td>
                  </tr>
                  <tr>
                  <td class="attName">Optimalna temperatura na vstopu (°C)</td>
                  <td class="attValue">{{ getHouseOsnovni(info)?.optimalna_temperatura_na_vstopu_c }}</td>
                  </tr>
                  <tr>
                  <td class="attName">Ocenjen prihranek zaradi optimizacije sistema (kWh/leto)</td>
                  <td class="attValue">{{ getHouseOsnovni(info)?.ocenjen_prihranek_optimizacija_kwh }}</td>
                  </tr>
                  <tr>
                  <td class="attName">Ocenjen prihranek ob znižanju temperature v stavbi za 2 K (kWh/leto)</td>
                  <td class="attValue">{{ getHouseOsnovni(info)?.ocenjen_prihranek_znizanje_2k_kwh }}</td>
                  </tr>
              </table>
              </ng-container>

              <!-- NAPOVED - STAVBA -->
              <ng-container *ngIf="isDistrictHeatingHouse(info) && getDistrictHeatingView(info) === 'napoved'">
              <table class="infoTable">
                  <tr>
                  <td class="attName">Naslov stavbe</td>
                  <td class="attValue" [attr.colspan]="getNapovedColumns(info).length">
                      {{ getHouseOsnovni(info)?.naslov }}
                  </td>
                  </tr>
                  <tr>
                  <td class="attName">Številka toplotne postaje</td>
                  <td class="attValue" [attr.colspan]="getNapovedColumns(info).length">
                      {{ getHouseOsnovni(info)?.stevilka_toplotne_postaje }}
                  </td>
                  </tr>
                  <tr>
                  <td class="attName">Nazivna toplotna moč stavbe (kW)</td>
                  <td class="attValue" [attr.colspan]="getNapovedColumns(info).length">
                      {{ getHouseOsnovni(info)?.nazivna_toplotna_moc_kw }}
                  </td>
                  </tr>
                  <tr>
                  <td class="attName">Ocenjena letna raba energije (kWh/leto)</td>
                  <td class="attValue" [attr.colspan]="getNapovedColumns(info).length">
                      {{ getHouseOsnovni(info)?.ocenjena_letna_raba_energije_kwh }}
                  </td>
                  </tr>
              </table>

              <br>

              <table class="infoTable">
                  <tr>
                  <th class="attName">Podatek</th>
                  <th class="attValue" *ngFor="let c of getNapovedColumns(info)" [innerHTML]="formatSlDate(c)">
                  </th>
                  </tr>
                  <tr *ngFor="let row of buildNapovedRows(info)">
                  <td class="attName">
                      {{ row.naziv }}
                      <span *ngIf="row.enota"> ({{ row.enota }})</span>
                  </td>
                  <td class="attValue" *ngFor="let c of getNapovedColumns(info)">
                      {{ formatSlNumber(row[c]) }}
                  </td>
                  </tr>
              </table>
              </ng-container>

              <!-- ZGODOVINA - STAVBA -->
              <ng-container *ngIf="isDistrictHeatingHouse(info) && getDistrictHeatingView(info) === 'zgodovina'">
              <table class="infoTable">
                  <tr>
                  <td class="attName">Naslov stavbe</td>
                  <td class="attValue" [attr.colspan]="getZgodovinaColumns(info).length">
                      {{ getHouseOsnovni(info)?.naslov }}
                  </td>
                  </tr>
                  <tr>
                  <td class="attName">Številka toplotne postaje</td>
                  <td class="attValue" [attr.colspan]="getZgodovinaColumns(info).length">
                      {{ getHouseOsnovni(info)?.stevilka_toplotne_postaje }}
                  </td>
                  </tr>
                  <tr>
                  <td class="attName">Nazivna toplotna moč stavbe (kW)</td>
                  <td class="attValue" [attr.colspan]="getZgodovinaColumns(info).length">
                      {{ getHouseOsnovni(info)?.nazivna_toplotna_moc_kw }}
                  </td>
                  </tr>
                  <tr>
                  <td class="attName">Ocenjena letna raba energije (kWh/leto)</td>
                  <td class="attValue" [attr.colspan]="getZgodovinaColumns(info).length">
                      {{ getHouseOsnovni(info)?.ocenjena_letna_raba_energije_kwh }}
                  </td>
                  </tr>
              </table>

              <br>

              <table class="infoTable">
                  <tr>
                  <th class="attName">Podatek</th>
                  <th class="attType">Vrsta</th>
                  <th class="attValue" *ngFor="let c of getZgodovinaColumns(info)" [innerHTML]="formatSlDate(c)">
                  </th>
                  </tr>

                  <ng-container *ngFor="let group of buildZgodovinaGroups(info)">
                  <tr *ngFor="let row of group.rows; let i = index">

                      <td
                      *ngIf="i === 0"
                      class="attName"
                      [attr.rowspan]="group.rows.length"
                      >
                      {{ group.naziv }}
                      <span *ngIf="group.enota"> ({{ group.enota }})</span>
                      </td>

                      <td class="attType">
                      {{ row.vrsta }}
                      </td>

                      <td class="attValue" *ngFor="let c of getZgodovinaColumns(info)">
                      {{ formatSlNumber(row[c]) }}
                      </td>

                  </tr>
                  </ng-container>
              </table>
              </ng-container>


            </div>
          </div>

          <div class="streetWrap" *ngIf="info.streetViewUrl != undefined">
            <iframe
              class="streetFrame"
              [src]="info.streetViewUrl">
            </iframe>
          </div>

          <div class="actionRow">
            <button
              type="button"
              class="easBtn"
              [class.active-dh-btn]="info.activeAction === 'zoom'"
              (click)="selectFeature(info)">
              Približaj
            </button>
            
            <button
              type="button"
              class="easBtn"
              [class.active-dh-btn]="info.activeAction === 'streetview'"
              (click)="gsw(info)">
              StreetView
            </button>

            <ng-container *ngIf="isDistrictHeatingInfo(info)">
              <button
                type="button"
                class="easBtn"
                [class.active-dh-btn]="getDistrictHeatingView(info) === 'overview'"
                (click)="setDistrictHeatingView(info, 'overview')">
                Podatki
              </button>

              <button
                type="button"
                class="easBtn"
                [class.active-dh-btn]="getDistrictHeatingView(info) === 'napoved'"
                (click)="setDistrictHeatingView(info, 'napoved')">
                Napoved
              </button>

              <button
                type="button"
                class="easBtn"
                [class.active-dh-btn]="getDistrictHeatingView(info) === 'zgodovina'"
                (click)="setDistrictHeatingView(info, 'zgodovina')">
                Zgodovina
              </button>
            </ng-container>

            <button
              *ngIf="info.reportid !== null && info.reportname !== null && info.reportlabel !== null"
              type="button"
              class="easBtn"
              (click)="openReport(info.reportparam, info.reportid, info.reportname)">
              {{info.reportlabel}}
            </button>

            <ng-container *ngIf="additionalButtons.length">
              <button
                *ngFor="let btn of additionalButtons"
                type="button"
                class="easBtn"
                [class.active-dh-btn]="info.activeAction === ('extra:' + btn.btnControl)"
                (click)="aditionalBtnsController(btn.btnControl, info)">
                {{btn.btnName}}
              </button>
            </ng-container>
          </div>
        </div>
      </p-tabpanel>
    </p-tabpanels>

  </p-tabs>
</p-dialog>